module.exports = __webpack_public_path__ + "static/media/reshot-icon-user-QLCUYJBKM3 1.45f78770.svg";